import React, { useState } from 'react';

const BeforeAfterSlider = () => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const [activeComparison, setActiveComparison] = useState(0);

  const comparisons = [
    {
      before: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/n0yh6lba_IMG_3613.jpeg',
      after: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/q0xu1dmc_IMG_3642.jpeg',
      title: 'Exterior Detail - Chrysler 300'
    },
    {
      before: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/hx9b5578_IMG_3208.jpeg',
      after: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/f659pe9y_IMG_3233.jpeg',
      title: 'Interior Detail - RAV4 Trunk'
    }
  ];

  const handleMove = (e) => {
    if (!isDragging && e.type !== 'mousemove' && e.type !== 'touchmove') return;
    
    const container = e.currentTarget.getBoundingClientRect();
    let position;
    
    if (e.type === 'touchmove') {
      position = ((e.touches[0].clientX - container.left) / container.width) * 100;
    } else {
      position = ((e.clientX - container.left) / container.width) * 100;
    }
    
    setSliderPosition(Math.max(0, Math.min(100, position)));
  };

  const currentComparison = comparisons[activeComparison];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            See The <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-amber-400">Transformation</span>
          </h2>
          <p className="text-gray-400 text-lg mb-6">
            Drag the slider to see real before and after results from our work
          </p>
          
          {/* Comparison Selector */}
          <div className="flex justify-center gap-4 mb-8">
            {comparisons.map((comp, index) => (
              <button
                key={index}
                onClick={() => {
                  setActiveComparison(index);
                  setSliderPosition(50);
                }}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                  activeComparison === index
                    ? 'bg-gradient-to-r from-yellow-500 to-amber-400 text-black'
                    : 'bg-zinc-800 text-gray-400 hover:text-white hover:bg-zinc-700'
                }`}
              >
                {comp.title}
              </button>
            ))}
          </div>
        </div>

        <div className="relative">
          <div
            className="relative w-full aspect-video rounded-2xl overflow-hidden cursor-ew-resize select-none border-2 border-yellow-500/20 shadow-2xl"
            onMouseMove={handleMove}
            onTouchMove={handleMove}
            onMouseDown={() => setIsDragging(true)}
            onMouseUp={() => setIsDragging(false)}
            onMouseLeave={() => setIsDragging(false)}
            onTouchStart={() => setIsDragging(true)}
            onTouchEnd={() => setIsDragging(false)}
          >
            {/* Before Image (Right Side) */}
            <div className="absolute inset-0">
              <img
                src={currentComparison.before}
                alt="Before detailing"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg">
                BEFORE
              </div>
            </div>

            {/* After Image (Left Side) - Clipped by slider position */}
            <div 
              className="absolute inset-0 overflow-hidden"
              style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
            >
              <img
                src={currentComparison.after}
                alt="After detailing"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 bg-gradient-to-r from-yellow-500 to-amber-400 text-black px-4 py-2 rounded-lg font-bold text-sm shadow-lg">
                AFTER
              </div>
            </div>

            {/* Slider Line and Handle */}
            <div
              className="absolute top-0 bottom-0 w-1 bg-yellow-400 cursor-ew-resize z-10"
              style={{ left: `${sliderPosition}%` }}
            >
              {/* Handle */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-gradient-to-r from-yellow-500 to-amber-400 rounded-full shadow-lg flex items-center justify-center">
                <div className="flex gap-1">
                  <div className="w-0.5 h-4 bg-black"></div>
                  <div className="w-0.5 h-4 bg-black"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Instructions */}
          <div className="mt-6 text-center">
            <p className="text-gray-500 text-sm">
              <span className="hidden md:inline">Click and drag</span>
              <span className="md:hidden">Tap and drag</span> the slider to compare
            </p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="flex justify-center mt-16">
          <div className="bg-zinc-900/50 backdrop-blur-sm border border-yellow-500/20 rounded-xl p-8 text-center hover:border-yellow-500 transition-all duration-300 max-w-md">
            <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-amber-400 mb-3">
              100%
            </div>
            <p className="text-gray-400 text-lg">Mobile Service</p>
            <p className="text-gray-500 text-sm mt-2">We come to you - home, office, or anywhere</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSlider;
